import { render, staticRenderFns } from "./FormSubCategories.vue?vue&type=template&id=03f8579c&scoped=true"
import script from "./FormSubCategories.vue?vue&type=script&lang=js"
export * from "./FormSubCategories.vue?vue&type=script&lang=js"
import style0 from "./FormSubCategories.vue?vue&type=style&index=0&id=03f8579c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f8579c",
  null
  
)

export default component.exports